import 'owl.carousel';

export default {
	init() {
	// JavaScript to be fired on all pages

	$('.complete-link').click(function() {
		window.location = $(this).find('a').attr('href'); 
		return false;
	});

	$('.change-lang').click(function(){
		if($('body').hasClass('lang-eng')) {
			$('body').removeClass('lang-eng'); 
			$('body').addClass('lang-nl');
		}
		else {
			$('body').removeClass('lang-nl'); 
			$('body').addClass('lang-eng');
		}
	});
},
finalize() {
	// JavaScript to be fired on all pages, after page specific JS is fired
},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js